export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const GET_SESSION_ERROR = 'GET_SESSION_ERROR';
export const GET_USER_SESSION_SUCCESS = 'GET_USER_SESSION_SUCCESS';
export const GET_USER_SESSION_ERROR = 'GET_USER_SESSION_ERROR';
export const INVALID_SESSION = 'INVALID_SESSION';
